import type {
  ExitAttachmentUploadResult,
  TerminationDocumentUploadResult,
} from "./types";

export function pickUploadedAttachmentFields(res: ExitAttachmentUploadResult): {
  attachmentFileUrl?: string;
  attachmentFileKey?: string;
  attachmentOriginalName?: string;
} {
  return {
    attachmentFileUrl: res.fileUrl ?? res.attachmentFileUrl,
    attachmentFileKey: res.fileKey ?? res.attachmentFileKey,
    attachmentOriginalName: res.originalName ?? res.attachmentOriginalName,
  };
}

export function pickTerminationUploadFields(
  res: TerminationDocumentUploadResult,
  originalName?: string,
): {
  fileUrl?: string;
  fileKey?: string;
  originalName?: string;
} {
  return {
    fileUrl: res.fileUrl,
    fileKey: res.fileKey ?? res.key,
    originalName: res.originalName ?? originalName,
  };
}

export function pickAttachmentLinkFromExit(
  row: Record<string, unknown>
): string | undefined {
  const attachment = row.attachment as Record<string, unknown> | undefined;
  
  const url =
    (typeof row.attachmentFileUrl === "string" && row.attachmentFileUrl) ||
    (typeof row.fileUrl === "string" && row.fileUrl) ||
    (typeof row.signedUrl === "string" && row.signedUrl) ||
    (typeof row.attachmentSignedUrl === "string" && row.attachmentSignedUrl) ||
    (attachment && typeof attachment.signedUrl === "string" && attachment.signedUrl) ||
    (attachment && typeof attachment.fileUrl === "string" && attachment.fileUrl);
    
  return url || undefined;
}

export function pickAttachmentNameFromExit(
  row: Record<string, unknown>
): string | undefined {
  const attachment = row.attachment as Record<string, unknown> | undefined;
  
  const name =
    (typeof row.attachmentOriginalName === "string" && row.attachmentOriginalName) ||
    (typeof row.originalName === "string" && row.originalName) ||
    (attachment && typeof attachment.originalName === "string" && attachment.originalName);
    
  return name || undefined;
}

export function extractFilenameFromUrl(url: string): string {
  if (!url) return "Document";
  try {
    const urlObj = new URL(url);
    const pathname = urlObj.pathname;
    const parts = pathname.split("/");
    let lastPart = parts[parts.length - 1];
    if (lastPart) {
      let decoded = decodeURIComponent(lastPart);
      const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}[-_]/i;
      decoded = decoded.replace(uuidRegex, "");
      return decoded || "Document";
    }
  } catch (e) {
    const cleanUrl = url.split("?")[0];
    const parts = cleanUrl.split("/");
    let lastPart = parts[parts.length - 1];
    if (lastPart) {
      let decoded = decodeURIComponent(lastPart);
      const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}[-_]/i;
      decoded = decoded.replace(uuidRegex, "");
      return decoded || "Document";
    }
  }
  return "Document";
}

